import { render } from "./TrainerFinance.vue?vue&type=template&id=5ff07b94"
import script from "./TrainerFinance.vue?vue&type=script&lang=js"
export * from "./TrainerFinance.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__